// extracted by mini-css-extract-plugin
export default {"divBtn":"ButtonB_divBtn__DNC3G","btn":"ButtonB_btn__2GmA9"};